
import {protoUI} from "../ui/core";
import template from "../views/template";

protoUI({ name:"daterangepicker", defaults:{
	template:"GPL version doesn't support daterangepicker <br> You need Webix PRO"
}}, template.view);